import { useMemo } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import { AboutPage } from './AboutPage/AboutPage';
import GamePage from './GamePage/GamePage';
import { HomePage } from './HomePage/HomePage';
import { LeaderboardPage } from './LeaderboardPage/LeaderboardPage';
import { MedalsPage } from './MedalsPage/MedalsPage';
import RootPage from './RootPage/RootPage';
import ToolsPage from './ToolsPage/ToolsPage';

const BrowserRoutes = () => {
  const location = useLocation();

  const PageBehindDrawer = useMemo(() => {
    const previousPath = location.state?.prevPathname ?? '/';

    switch (previousPath) {
      case '/leaderboard':
        return <LeaderboardPage />;
      case '/tools':
        return <ToolsPage />;
      case '/about':
        return <AboutPage />;
      case '/game':
      case '/game/leaderboard':
        return <GamePage />;
      case '/':
      default:
        return <HomePage />;
    }
  }, [location.state?.prevPathname]);

  return (
    <Routes>
      <Route path="/" element={<RootPage />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={PageBehindDrawer} />
        <Route path="/signup" element={PageBehindDrawer} />
        <Route path="/profile" element={PageBehindDrawer} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/medals" element={<MedalsPage />} />
        <Route path="/tools/*" element={<ToolsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/user/:userId" element={PageBehindDrawer} />
        <Route path="/game/*" element={<GamePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export const Router = () => {
  return (
    <BrowserRouter>
      <BrowserRoutes />
    </BrowserRouter>
  );
};
